import { apolloClient } from '~/apollo-client';

import {
  Flex_SendDocuSignInstantAlertMutation,
  Flex_SendDocuSignInstantAlertMutationVariables,
  FunnelTrack,
} from '~/typings/graphql';

import { SEND_DOCU_SIGN_INSTANT_ALERT } from './send-docusign-instant-alert.queries';

export type SendDocusignInstantAlertParams = {
  utilityAccountId: number;
  track: FunnelTrack;
  userIp: string;
  inviteCode: string;
};

export type SendDocusignInstantAlertResponse = {
  success: boolean;
};

export const sendDocusignInstantAlert = async (
  params: SendDocusignInstantAlertParams,
): Promise<SendDocusignInstantAlertResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_SendDocuSignInstantAlertMutation,
    Flex_SendDocuSignInstantAlertMutationVariables
  >({
    mutation: SEND_DOCU_SIGN_INSTANT_ALERT,
    variables: {
      input: {
        utilityAccountId: params.utilityAccountId,
        track: params.track,
        userIp: params.userIp,
        inviteCode: params.inviteCode,
      },
    },
  });

  return {
    success: data?.docusignInstantAlert.success!,
  };
};
